import { GradientButton } from '@components/Button/GradientButton';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface ProduceButtonProps {
  onClick: () => void;
  isProducing: boolean;
  disabled?: boolean;
  className?: string;
  style?: React.CSSProperties;
}

export const ProduceButton: React.FC<ProduceButtonProps> = ({
  onClick,
  isProducing,
  disabled = false,
  className = '',
  style,
}) => {
  const { t } = useTranslation();
  return (
    <div className={className} style={style}>
      <GradientButton
        onClickHandle={onClick}
        disabled={disabled}
        icon={isProducing ? undefined : undefined}
        title={isProducing ? t('generation.producing') : t('generation.produce')}
        isAnimating={isProducing}
      />
    </div>
  );
};
